import { useActiveBanners } from "@/hooks/useMarketingBanners";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { Timer } from "lucide-react";
import ScrollReveal from "@/components/3d/ScrollReveal";
import MagneticButton from "@/components/3d/MagneticButton";

const MarketingBanner = () => {
  const { data: banners = [] } = useActiveBanners();
  
  if (banners.length === 0) return null;
  
  const banner = banners[0];
  const { headline, body, cta_text, cta_url } = banner.content;
  
  if (!headline) return null;

  return (
    <section className="py-16">
      <div className="container mx-auto px-4">
        <ScrollReveal direction="scale">
          <div className="relative overflow-hidden rounded-3xl border border-primary/20 gradient-purple p-12 text-center sm:p-16">
            <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,transparent_20%,hsl(270_20%_4%/0.4)_100%)]" />
            <motion.div
              className="absolute -left-20 top-1/2 h-40 w-40 rounded-full bg-accent/20 blur-[80px]"
              animate={{ x: [0, 60, 0], y: [-50, 50, -50] }}
              transition={{ duration: 10, repeat: Infinity, ease: "easeInOut" }}
            />
            <div className="relative">
              <div className="mb-4 inline-flex items-center gap-2 rounded-full bg-background/20 px-4 py-1.5 text-xs font-semibold uppercase tracking-wider text-primary-foreground backdrop-blur-sm">
                <Timer className="h-3 w-3" /> {banner.name}
              </div>
              <h2 className="font-display text-3xl font-black text-primary-foreground sm:text-5xl">
                {headline}
              </h2>
              {body && (
                <p className="mx-auto mt-4 max-w-md text-sm text-primary-foreground/80">
                  {body}
                </p>
              )}
              {cta_text && cta_url && (
                <MagneticButton className="inline-block mt-8" strength={0.25}>
                  <Link
                    to={cta_url}
                    className="inline-flex rounded-full bg-background px-8 py-3 font-display text-sm font-semibold text-foreground transition-colors hover:bg-background/90"
                  >
                    {cta_text}
                  </Link>
                </MagneticButton>
              )}
            </div>
          </div>
        </ScrollReveal>
      </div>
    </section>
  );
};

export default MarketingBanner;
